module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pa-1",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mx-auto",
    attrs: {
      "xs12": "",
      "sm9": ""
    }
  }, [(_vm.lAction === 'view') ? _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pt-2"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pa-0 mt-1",
    attrs: {
      "append-icon": "search",
      "placeholder": _vm.$vuetify.breakpoint.smAndUp ? 'Search user role name, desc, etc...' : 'Search',
      "single-line": "",
      "hide-details": "",
      "clearable": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-download-as', {
    attrs: {
      "headers": _vm.roleHead,
      "items": _vm.rolesList,
      "title": "User Roles list"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-1"
  }, [_c('div', {
    staticClass: "text-xs-right caption ma-2 grey--text"
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("lock")]), _vm._v(" - System defaults whose name can not be modified\n            ")], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-2",
    attrs: {
      "headers": _vm.roleHead,
      "items": _vm.rolesList,
      "search": _vm.search,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          on: {
            "click": function($event) {
              return _vm.prepareUpdate(props.item)
            }
          }
        }, [_c('td', [_vm._v(_vm._s(props.item.role_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.role_type))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.role_desc))]), _vm._v(" "), _c('td', [(props.item.is_system_role) ? _c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("lock")]) : _vm._e()], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.tot_users))])])]
      }
    }], null, false, 4033924181)
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.lAction === 'create' || _vm.lAction === 'update') ? _c('v-container', {
    staticClass: "pa-1",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-form', {
    ref: "lForm",
    attrs: {
      "id": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveChanges(_vm.lAction)
      }
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "px-0 py-2 title"
  }, [_vm._v("\n                  " + _vm._s(_vm.handy.startWithUpper(_vm.lAction) + ' Role') + "\n                ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "px-0 py-3"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Role Name",
      "rules": [_vm.rules.required],
      "maxlength": "25",
      "hint": _vm.lUserRole.is_system_role ? 'Not possible to update system role name & type' : '',
      "persistent-hint": "",
      "disabled": _vm.lUserRole.is_system_role === 1
    },
    model: {
      value: (_vm.lUserRole.role_name),
      callback: function($$v) {
        _vm.$set(_vm.lUserRole, "role_name", $$v)
      },
      expression: "lUserRole.role_name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Type",
      "items": ['Resident', 'RWA', 'Staff', 'Others'],
      "disabled": _vm.lUserRole.is_system_role === 1,
      "rules": [_vm.rules.required]
    },
    model: {
      value: (_vm.lUserRole.role_type),
      callback: function($$v) {
        _vm.$set(_vm.lUserRole, "role_type", $$v)
      },
      expression: "lUserRole.role_type"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Role Description",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "rows": "3",
      "maxlength": "200"
    },
    model: {
      value: (_vm.lUserRole.role_desc),
      callback: function($$v) {
        _vm.$set(_vm.lUserRole, "role_desc", $$v)
      },
      expression: "lUserRole.role_desc"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-subheader', {
    staticClass: "primary--text pa-0"
  }, [_vm._v("Screen Access")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "max-auto": ""
    }
  }, [_c('v-data-table', {
    staticClass: "elevation-2",
    attrs: {
      "headers": _vm.accHead,
      "items": _vm.lUserRole.role_screen_access_list,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [(props.item.screen_type === 'm') ? _c('td', {
          staticClass: "title grey lighten-3",
          attrs: {
            "colspan": "3"
          }
        }, [_vm._v(_vm._s(props.item.screen_name))]) : _c('td', [_vm._v(_vm._s(props.item.screen_name))]), _vm._v(" "), (props.item.screen_type !== 'm') ? _c('td', [_c('v-checkbox', {
          attrs: {
            "hide-details": ""
          },
          model: {
            value: (props.item.view_access),
            callback: function($$v) {
              _vm.$set(props.item, "view_access", $$v)
            },
            expression: "props.item.view_access"
          }
        })], 1) : _vm._e()])]
      }
    }], null, false, 2793927015)
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [(_vm.lAction === 'update') ? _c('v-btn', {
    attrs: {
      "flat": "",
      "disabled": _vm.lUserRole.is_system_role === 1
    },
    on: {
      "click": function($event) {
        return _vm.deleteRole()
      }
    }
  }, [_vm._v("delete")]) : _vm._e(), _vm._v(" "), (_vm.lUserRole.is_system_role) ? _c('span', {
    staticClass: "caption pl-3"
  }, [_vm._v("Not possible to delete system roles")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.lAction = 'view'
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "type": "submit",
      "color": "accent",
      "disabled": _vm.beingSaved
    }
  }, [_vm._v("save")])], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.lAction === 'view') ? _c('v-btn', {
    style: ('position:fixed; ' + (_vm.$vuetify.breakpoint.smAndDown ? 'bottom:20px; right:15px;' : 'bottom:15px; right:15px;')),
    attrs: {
      "dark": "",
      "fab": "",
      "fixed": "",
      "color": "accent"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.prepareCreate($event)
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": _vm.sbarCol,
      "timeout": 3000,
      "multi-line": ""
    },
    model: {
      value: (_vm.sbar),
      callback: function($$v) {
        _vm.sbar = $$v
      },
      expression: "sbar"
    }
  }, [_c('span', {
    staticClass: "mx-auto"
  }, [_vm._v(_vm._s(_vm.sbarMsg))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6837cf96","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Roles.vue
// module id = 807
// module chunks = 16